import React, { PureComponent } from 'react';
import { Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, Line, ComposedChart} from 'recharts';
import AnalyticsTooltip from './AnalyticsTooltip';

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload

    return (
      <AnalyticsTooltip
        kicker="Monthly Activity"
        title={data.sessionLabel}
        rows={[
          { label: "Successful Queries", value: data.totalHits },
          { label: "Total Hits", value: data.totalHits },
          { label: "Tier 1 New", value: data.tier1New },
          { label: "Tier 2 New", value: data.tier2New },
          { label: "Tier 2 Upgraded", value: data.tier2Upgraded },
          { label: "Records Verified", value: data.recordsVerified },
        ]}
      />
    );
  }

  return null;
};

export default class MonthlyTwoYearChart extends PureComponent {
  
  render() 
  {
    return (
      <ResponsiveContainer width="100%" height="100%" minHeight={320}>
        <ComposedChart
          data={this.props.monthlyStatsTwoYear}
          layout="horizontal"
          margin={{
            top: 8,
            right: 18,
            left: 18,
            bottom: 6,
          }}
        >
          <XAxis dataKey="sessionLabel" tick={{fontSize: 12, fill: "#666C78"}} tickLine={{stroke: "#BDBFC4"}} axisLine={{stroke: "#D4D6DB"}} />
          <YAxis label={{ value: 'Lead Discoveries', angle: -90, position: '' }} dataKey="totalNewLeads" type="number" domain={[0, dataMax => (dataMax * 2)]} yAxisId="left" orientation="left" stroke="#5a5c68" tick={{fontSize: 12, fill: "#666C78"}} tickLine={{stroke: "#BDBFC4"}} axisLine={{stroke: "#D4D6DB"}} />
          <YAxis label={{ value: 'Records Scanned Successfully', angle: 90, position: 'top', dy: 80}} dataKey="successfulQueries" type="number" domain={[0, dataMax => (Math.round(dataMax + (dataMax * 0.1)))]} yAxisId="right" orientation="right" stroke="#5a5c68" tick={{fontSize: 12, fill: "#666C78"}} tickLine={{stroke: "#BDBFC4"}} axisLine={{stroke: "#D4D6DB"}} />
          <Tooltip content={<CustomTooltip/>} cursor={{fill: `rgba(147, 149, 153, 0.12)`}} />
          <Legend wrapperStyle={{fontSize: "0.78rem", fontWeight: 700, color: "#666C78", paddingTop: "0.35rem"}} />
          <Line yAxisId="right" type="monotone" dataKey="successfulQueries" stroke="#939599" />
          <Bar yAxisId="left" dataKey="tier1New" fill="#5EC969" stackId="a" name="New Tier 1" />
          <Bar yAxisId="left" dataKey="tier2New" fill="#4CA855" stackId="a" name="New Tier 2" />
          <Bar yAxisId="left" dataKey="tier2Upgraded" fill="#DEABEB" stackId="b" name="Upgraded Tier 2" />
          <Bar yAxisId="left" dataKey="tier1Updated" fill="#A0B7F2" stackId="b" name="Updated Tier 1" />
          <Bar yAxisId="left" dataKey="tier2Updated" fill="#6E88CC" stackId="b" name="Updated Tier 2" />
          <Bar yAxisId="left" dataKey="recordsVerified" fill="#B486BF" stackId="c" name="Records Verified" />
        </ComposedChart>
      </ResponsiveContainer>
    );
  }
}
